<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2020 (original work) Open Assessment Technologies SA ;
    import { Progressbar } from '@oat-sa-private/ui-elements';

    export let data;
</script>

{#if data || data === 0}
    <Progressbar value={data} max={100} valueLabel={`${Math.round(data)}%`} />
{/if}
